const st = {
  bannerWrapper: {
    width: '100%',
    height: '1.4rem',
    position: 'relative',
    /* background-color: red; */
    overflow: 'hidden',
    marginBottom: '.2rem',
    marginTop: '.2rem',
    paddingLeft: '.2rem',
    paddingRight: '.2rem'
  },
  bannerSwiper: {
    width: '100%',
    height: '1.4rem',
    borderRadius: '.08rem'
  },
  swiperItem: {
    width: '100%',
    height: '1.4rem',
    objectFit: 'contain',


  },
  
}

export default st;


